import { memo } from 'react';

const Index = (props) => (
  <div className="avatars-group table-responsive">{props.children}</div>
);

export default memo(Index);